/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * APIs Clickar.biz international.
 *
 * OpenAPI spec version: API V1
 * Contact: blureply@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
	HttpClient,
	HttpEvent,
	HttpHeaders,
	HttpParams,
	HttpResponse
} from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";

import { Observable } from "rxjs";

import { environment } from "@app/../environments/environment";
import { HeaderKey } from "@shared/clickar-constants";
import { Dealer, DealerInfoDTO } from "@shared/model/dealer.model";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";

@Injectable()
export class DealerService {
	protected basePath = "http://localhost:8088";
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		this.basePath = environment.baseApiUrl;

		if (configuration) {
			this.configuration = configuration;
			this.basePath = environment.baseApiUrl || configuration.basePath || this.basePath;
		}
	}

	getDealerInfoUsingGET(dealerId: number, observe?: "body", reportProgress?: boolean): Observable<DealerInfoDTO> {
		let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
		if (dealerId !== undefined && dealerId !== null) {
			queryParameters = queryParameters.set("dealerId", <any>dealerId);
		}

		return this.httpClient.get<DealerInfoDTO>(`${this.basePath}/api/v1/open/dealer-info`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * registerDealer
	 *
	 * @param dealerFullDTO dealerFullDTO
	 * @param files files
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	registerDealerUsingPOST(dealerFullDTO: any, files: Blob[], names: string[], observe?: "body", reportProgress?: boolean): Observable<any>;
	registerDealerUsingPOST(dealerFullDTO: any, files: Blob[], names: string[], observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	registerDealerUsingPOST(dealerFullDTO: any, files: Blob[], names: string[], observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	registerDealerUsingPOST(dealerFullDTO: any, files: Blob[], names: string[], observe: any = "body", reportProgress = false): Observable<any> {
		if (dealerFullDTO === null || dealerFullDTO === undefined) {
			throw new Error("Required parameter dealerFullDTO was null or undefined when calling registerDealerUsingPOST.");
		}

		/* if (files === null || files === undefined) {
			throw new Error("Required parameter files was null or undefined when calling registerDealerUsingPOST.");
		} */

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		// tslint:disable-next-line:triple-equals
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		const convertFormParamsToString = false,
			formParams = new FormData();


		if (dealerFullDTO !== undefined) {
			formParams.append("dealerFullDTO", new Blob([JSON.stringify(dealerFullDTO)], { type: "application/json" }));
		}
		if (files) {
			files.forEach((element, index) => {
				formParams.append("files", new Blob([element]), names[index]);
			});
		}
		headers = headers.set("form-data", "true");

		return this.httpClient.post<any>(`${this.basePath}/api/v1/open/sign-up`,
			convertFormParamsToString ? formParams.toString() : formParams,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	registerUserUsingPOST(dealer: Dealer, observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = ["application/json"],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected)
				.set(HeaderKey.NO_SUCCESS_POPUP, "true");
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/open/sign-up`,
			dealer,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}
}